import React from "react";
import { useTranslation } from "react-i18next";
import {
  Radio,
  RadioGroup,
  FormControlLabel, 
  FormControl,
} from "@mui/material";
import RadioButtonsProps from "./RadioButtonsProps";
import "../../assets/scss/variables.scss";

const RadioButtons = (props: RadioButtonsProps) => {
  const { t } = useTranslation("common");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.setRadioValue((event.target as HTMLInputElement).value);
  };

  return (
    <>
      <FormControl component="fieldset">
        {props.title? <legend >{props.title}</legend> : null}
        <RadioGroup
          name="controlled-radio-buttons-group"
          value={props.radioValue}
          onChange={handleChange} 
          row={props.column ? false : true}
        >
          <FormControlLabel
            value={t(props.firstRadioTString)}
            control={
              <Radio
              disableRipple
                size="small"
                sx={{
                  color: "#6c6c6d",
                  "&.Mui-checked": { color: "#0250C1" },
                }}                
                name="radio-btn"
                id={"radio-btn-A"} 
                //TODO if need for Accessibility
                // inputProps={{
                //   'aria-label': 'Radio A',
                // }}
              />
            }
            label={
              <span className="custom-radio-label">
                {t(props.firstRadioTString)}
              </span>
            }
          />
          <FormControlLabel
            value={t(props.secondRadioTString)}
            control={
              <Radio
              disableRipple
                size="small"
                sx={{
                  color: "#6c6c6d",
                  "&.Mui-checked": { color: "#0250C1" },
                }}
                name="radio-btn"
                id={"radio-btn-B"} 
              />
            }
            label={
              !props.mobileRender ? (
                <span className="custom-radio-label">
                  {t(props.secondRadioTString)}
                </span>
              ) : (
                ""
              )
            }
          />
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default RadioButtons;
